export const Namespaces = {
  FAMILY_ADMIN: 'family_admin',
  COACH: 'coach',
  ADMIN: 'admin',
}

export const namespacedPath = (path, namespace) => {
  if (!namespace) {
    return path
  }

  const parts = path.split('/').filter(Boolean)
  const [api, version, ...rest] = parts

  return `/${api}/${version}/${namespace}/${rest.join('/')}`
}
